import * as React from "react";
import { NoEntitiesExist } from "components/common";
import VulnerabilitiesInfo from "./VulnerabilitiesInfo";
import PortList from "./PortList";
import { NoEntitiesExistWrapper } from "../shared";
function Vulnerabilities({ asset }) {
  const hasVulnerabilities = asset.vulnerabilities.some(
    (vuln) => {
      var _a;
      return ((_a = vuln.vulnerabilities) == null ? void 0 : _a.length) > 0;
    }
  );
  const allPorts = asset.vulnerabilities.reduce(
    (acc, vuln) => {
      (vuln.ports || []).forEach((inPort) => {
        if (!acc.find(
          (p) => `${p.port}${p.protocol}` === `${inPort.port}${inPort.protocol}`
        )) {
          acc.push(inPort);
        }
      });
      return acc;
    },
    []
  );
  if (!hasVulnerabilities) {
    return /* @__PURE__ */ React.createElement(NoEntitiesExistWrapper, null, /* @__PURE__ */ React.createElement(NoEntitiesExist, null, "This asset doesn't have any vulnerabilities reported"));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(VulnerabilitiesInfo, { assetId: asset.id }), /* @__PURE__ */ React.createElement("strong", null, "Ports"), /* @__PURE__ */ React.createElement(PortList, { ports: allPorts }));
}
export default Vulnerabilities;
